// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__26t8E","bigColWidth":"Table_bigColWidth__vePBF","biggerColWidth":"Table_biggerColWidth__2ea5n","row":"Table_row__rcZzY","col":"Table_col__1ktG8"};